/*
* QuotesReducer
*/

import { fromJS } from 'immutable';
import {
  GET_QUOTATION,
  PRINT_QUOTATION,
  QUOTATION_RECEIVED,
  DISPLAY_QUOTATION_ASSISTANT,
  UPDATE_QUOTATION_STATUS,
} from './constants';
import { SAVE_QUOTATION_SUCCESS, SAVE_PROPOSAL_SUCCESS } from 'components/Quotation/constants';

// The initial state of the App
export const initialState = fromJS({
  quotation: {},
  newStatus: 'OPEN',
  quotationLoaded: false,
  displayAssistant: false,
});

function quotationPageReducer(state = initialState, action) {
  switch (action.type) {
    case GET_QUOTATION:
      return state
        .set('proposal_id', action.proposal_id)
        .set('loading', true);
    case PRINT_QUOTATION:
      return state.set('code', action.id);
    case UPDATE_QUOTATION_STATUS:
      return state.set('loading', true).set('newStatus', action.newStatus);
    case QUOTATION_RECEIVED:
      return state
        .set('quotation', action.quotation)
        .set('newStatus', action.quotation.status || 'OPEN')
        .set('quotationLoaded', true)
        .set('loading', false);
    case SAVE_PROPOSAL_SUCCESS:
    case SAVE_QUOTATION_SUCCESS:
      return state
        .set('quotation', action.data)
        .set('newStatus', action.data.status)
        .set('quotationLoaded', true)
        .set('loading', false);
    case DISPLAY_QUOTATION_ASSISTANT:
      return state.set('displayAssistant', action.display);
    default:
      return state;
  }
}

export default quotationPageReducer;
